// extracted by mini-css-extract-plugin
module.exports = {"simpleFooter":"SimpleFooter_simpleFooter__7Vl1m","head":"SimpleFooter_head__GS_pi","logo":"SimpleFooter_logo__Lf_gG","copyright":"SimpleFooter_copyright__RB75v"};